// extracted by mini-css-extract-plugin
export default {"notificationSection":"NotificationList_notificationSection__0YNEe","cardTitle":"NotificationList_cardTitle__+OWNt","notificationList":"NotificationList_notificationList__PFECb"};